import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import { FUMIGADO_SCHEMA } from '../../constants'

export const OperacionNuevoFumigadoView = ({ silo: { nombreCorto }, aceptar, cancelar }) => (
  <Formik initialValues={{ producto: '', observaciones: '' }} onSubmit={aceptar} validationSchema={FUMIGADO_SCHEMA}>
    {({ isSubmitting, isValid }) => (
      <Form>
        <Grid container spacing={2} direction='column' justify='space-around'>
          <Grid container item spacing={2}>
            <Grid item xs={12}>
              <Typography variant='h6'>Fumigado de {nombreCorto}</Typography>
            </Grid>
          </Grid>
          <Grid container item spacing={2}>
            <Grid item xs={12} sm={6}>
              <Field component={TextField} name='producto' type='text' label='Producto' />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field component={TextField} name='observaciones' type='text' label='Observaciones' />
            </Grid>
          </Grid>
          <Grid container item spacing={2} justify='space-between'>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='secondary'
                disabled={isSubmitting}
                startIcon={<HighlightOffIcon />}
                onClick={cancelar}>
                Cancelar
              </Button>
            </Grid>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='primary'
                disabled={isSubmitting || !isValid}
                startIcon={<CheckCircleOutlineIcon />}
                type='submit'>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
)
